/*globals Cookies*/

const CookieSet = (function (cookie, update_callback) {
	const _private = {
		is_stored: false,
		state: null,
		maximum: cookie === 'shop_recently' ? 20 : 0,
		params: {}
	};

	const self = {
		list: function () {
			if (!_private.is_stored) {
				const cookie_raw = Cookies.get(cookie) || '';

				if (cookie_raw.length === 0) {
					_private.state = [];
				}
				else {
					_private.state = cookie_raw.split(',');
				}

				_private.is_stored = true;
			}

			return _private.state;
		},
		count: function () {
			return self.list().length;
		},
		store: function (list) {
			if (list.length === 0) {
				Cookies.remove(cookie);
			}
			else {
				if (_private.maximum && list.length > _private.maximum) {
					list = list.slice(list.length - _private.maximum);
				}

				Cookies.set(cookie, list.join(','), {
					expires: 31
				});
			}

			_private.is_stored = false;
		},
		get: function (value) {
			if (_private.params[value]) {
				return _private.params[value];
			}

			return null;
		},
		has: function (value) {
			value = value.toString();
			const list = self.list();
			const result = list.indexOf(value) !== -1;

			return result;
		},
		add: function (value, params) {
			value = value.toString();

			if (self.has(value)) {
				return;
			}

			const list = self.list();
			list.push(value);
			self.store(list);
			_private.params[value] = params;
			self.update({
				action: 'add',
				value: value
			});
		},
		remove: function (value, params) {
			value = value.toString();

			if (!self.has(value)) {
				return;
			}

			const list = self.list();
			list.splice(list.indexOf(value), 1);
			self.store(list);
			_private.params[value] = params;
			self.update({
				action: 'remove',
				value: value
			});
		},
		update: function (info) {
			if (typeof update_callback === 'function') {
				update_callback(info);
			}
		}
	};

	return new Proxy(self, {
		get(target, p, receiver) {
			if (p === 'maximum') {
				return _private.maximum;
			}

			return target[p];
		},

		set(target, p, value, receiver) {
			if (p === 'maximum') {
				_private.maximum = value;
				return true;
			}

			target[p] = value;
			return true;
		}
	});
});

export default CookieSet;
